import { ReactNode } from 'react';

import {
  IconPaymentTypeAddNewPayment,
  IconPaymentTypeAmex,
  IconPaymentTypeApplePay,
  IconPaymentTypeDinersClub,
  IconPaymentTypeDiscover,
  IconPaymentTypeGenericCreditCard,
  IconPaymentTypeGooglePay,
  IconPaymentTypeJcb,
  IconPaymentTypeMastercard,
  IconPaymentTypeVisa,
} from '@fhs/ui';
import { CardBrand } from '@fhs-legacy/frontend/src/generated/graphql-gateway';

import type { ISavedCardInfo, PaymentMethodType } from '../../../payment/payment-types';

export type PaymentMethodLabelAndIcon = {
  icon: ReactNode;
  label: string;
};

export const cardBrandIconMap: Record<CardBrand, ReactNode> = {
  [CardBrand.VISA]: <IconPaymentTypeVisa size={24} />,
  [CardBrand.MASTERCARD]: <IconPaymentTypeMastercard size={24} />,
  [CardBrand.AMEX]: <IconPaymentTypeAmex size={24} />,
  [CardBrand.DISCOVER]: <IconPaymentTypeDiscover size={24} />,
  [CardBrand.DINERS_CLUB]: <IconPaymentTypeDinersClub size={24} />,
  [CardBrand.JCB]: <IconPaymentTypeJcb size={24} />,
};

export const paymentMethodLabelAndIcon: Record<string, PaymentMethodLabelAndIcon> = {
  googlePay: {
    icon: <IconPaymentTypeGooglePay size={24} />,
    label: 'Google Pay',
  },
  applePay: {
    icon: <IconPaymentTypeApplePay size={24} />,
    label: 'Apple Pay',
  },
  giftCard: {
    icon: <IconPaymentTypeGenericCreditCard size={24} />,
    label: 'Gift Card',
  },
  null: {
    icon: <IconPaymentTypeAddNewPayment size={24} />,
    label: 'Add New Credit Card',
  },
};

export function getPaymentMethodDisplay(
  paymentMethod: PaymentMethodType,
  savedCardInfo?: ISavedCardInfo
): PaymentMethodLabelAndIcon {
  if (paymentMethod === 'savedCard' && savedCardInfo) {
    return getSavedCardDisplay(savedCardInfo.cardType, savedCardInfo.alias);
  }

  return paymentMethodLabelAndIcon[paymentMethod ?? 'null'] || paymentMethodLabelAndIcon.null;
}

function getSavedCardDisplay(cardType: CardBrand, lastFour: string): PaymentMethodLabelAndIcon {
  // displays saved card info obfuscated, can be used with gift cards
  return {
    icon: cardBrandIconMap[cardType] || <IconPaymentTypeGenericCreditCard size={24} />,
    label: `${cardType} **** ${lastFour}`,
  };
}
